module.exports = __webpack_public_path__ + "img/trainExchange.8bf50c4e.png";